import hCrud from "./hCrud/index";
import hForm from "./hForm/index";
import hFormTable from "./hFormTable/index";
import hPaging from "./hPaging/index";
import hPreview from "./hPreview/index";
import hUpload from "./hUpload/index";
import hExport from "./hExport/index";
import hFullLoad from "./hFullLoad/index";
import hBorder from "./hBorder/index";

const components = [
  hCrud,
  hForm,
  hFormTable,
  hPaging,
  hPreview,
  hUpload,
  hExport,
  hFullLoad,
  hBorder
];

const install = function (Vue) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

export default {
  install,
  hCrud,
  hForm,
  hFormTable,
  hPaging,
  hPreview,
  hUpload,
  hExport,
  hFullLoad,
  hBorder
};
